<script>
	//export let name;
	import Grid from "svelte-grid-responsive";
</script>


<main>
    <Grid container gutter={12}>
	  <Grid xs={12} md={12} lg={12}>
	    <!--a href="https://github.com/andrelmlins/svelte-grid-responsive">Svelte Grid Responsive</a-->    
		<!--h1>Hello {name}!</h1-->
	    <h1>p2p</h1>
		<img src="https://imagedelivery.net/M-hNcUVb3g5noHADsiQNwQ/ecc664cb-96f0-4563-01c4-eedb1df67b00/public" alt='off the map' class="responsive">
		<p>
			<a class="twitter-follow-button"
			    href="https://twitter.com/IanGordonOne"
			    data-size="large">
			    Follow @IanGordonOne
		    </a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
		</p>
	  </Grid>
    </Grid>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 100%;
		margin: 0 auto;
	}

	h1 {
		/*color: #ff3e00;*/
		color: purple;
		font-size: 4em;
		font-weight: 100;
	}

	.responsive {
	    max-width: 100%;
		max-height: 100%;
	    margin: auto;
	}

	/*@media (min-width: 240px) {
		main {
			max-width: none;
		}
	}*/
</style>
